import { Theme } from '@mui/material';

const GRID_GAP = { xs: 2, md: 3 };

export const styles = {
  row: (theme: Theme) => ({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoFlow: 'row',
    gap: GRID_GAP,

    '& > div': {
      minWidth: 0, // the responsive chart elements will not shrink otherwise
    },

    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'none',
      gridAutoColumns: '1fr',
      gridAutoFlow: 'column',
    },
  }),
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: GRID_GAP,
  },
  tile: {
    p: 3,
    borderRadius: 4,
    backgroundColor: 'grey50',
  },
  tileWithMinHeight: {
    minHeight: 480,
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 88,
    ':not(:last-child)': {
      borderBottom: '1px solid',
      borderColor: 'divider',
    },
  },
  listItemImageSize: {
    width: 60,
    height: 60,
  },
};

export const SECTION_TITLE_VARIANT = 'h3';
